@if (show) {
  <div class="modal-content-container">
    <h1>{{ 'modal.profileFeesConfig.header' | translate }}</h1>
    <p [innerHTML]="'modal.profileFeesConfig.text1' | translate"></p>
    <p [innerHTML]="'modal.profileFeesConfig.text2' | translate"></p>
    <p>{{ 'modal.profileFeesConfig.text3' | translate }}</p>
    <div class="action-buttons-container">
      <libero-button
        label="{{ 'global.buttons.confirmRequest' | translate }}"
        btnClasses="btn--primary btn--heading btn--s-20"
        (click)="onContinueBtnClick()"
      ></libero-button>
      <libero-button
        label="{{ 'global.buttons.close' | translate }}"
        btnClasses="btn--secondary"
        (click)="onBackBtnClick()"
      ></libero-button>
    </div>
  </div>
}
